<template>
  <div>
    <a-button
      v-if="customType === 'router'"
      :style="
        `background-color:${bgc};font-size:${fz};border: 1px solid ${borderColor};color:${color}`
      "
      class="myButton"
    >
      <router-link :to="to">
        <slot />
        <a-icon v-if="showIcon" :type="iconType" class="ml5" />
        <img v-if="showImg" :src="imgSrc" class="ml5" alt="logo">
      </router-link>
    </a-button>

    <a-button
      v-if="customType === 'link'"
      :href="href"
      :style="
        `background-color:${bgc};font-size:${fz};border: 1px solid ${borderColor};color:${color}`
      "
      target="_blank"
      class="myButton"
    >
      <slot />
      <a-icon v-if="showIcon" :type="iconType" />
      <img v-if="showImg" :src="imgSrc" class="ml10" alt="logo">
    </a-button>

    <a-button
      v-if="customType === 'btn'"
      :style="
        `background-color:${bgc};font-size:${fz};border: 1px solid ${borderColor};color:${color}`
      "
      class="myButton"
      
      @click="onclick"
    >
      <slot />
      <a-icon v-if="showIcon" :type="iconType" />
      <img v-if="showImg" :src="imgSrc" class="ml10" alt="logo">
    </a-button>
  </div>
</template>

<script>
export default {
  props: {
    customType: {
      type: String,
      default: "link"
    },
    href: {
      type: String,
      default: "javascript:void(0)"
    },
    to: {
      type: String,
      default: "/"
    },
    iconType: {
      type: String,
      default: "arrow-right"
    },
    bgc: {
      type: String,
      default: "#fff"
    },
    fz: {
      type: String,
      default: "18px"
    },
    color: {
      type: String,
      default: "#3f4ae1"
    },
    borderColor: {
      type: String,
      default: "#3a43d8"
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showImg: {
      type: Boolean,
      default: false
    },
    imgSrc: {
      type: String
    },
    onclick:{
      type:Function,
      default:()=>{}
    }

  }
};
</script>

<style lang="less" scoped>
.myButton {
  height: 48px;
  font-size: 18px;
  // font-family: PingFangHK-Semibold, PingFangHK;
  font-weight: 600;
  border-radius: 2px;
}
</style>
